import React, { useState, useEffect } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import moment from "moment";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import { GetApp } from "@material-ui/icons";
import { CSVLink } from "react-csv";
import * as C from "components";
import assetConfig from "utils/pictree/AssetConfig";

const useStyles = makeStyles({
  loaderBox: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  loaderBarImg: {
    width: 40,
  },
  tableContainer: {
    display: "flex",
    minHeight: 200,
  },
  dateTableWrapper: {
    float: "left",
  },
  dataTableWrapper: {
    float: "left",
    overflow: "scroll",
  },
  leftTable: {
    border: "1px solid #eee",
  },
  lblGameName: {
    color: "#000",
    fontSize: 13,
    minWidth: 200,
  },
  lblUniqueUser: {
    color: "#6f6969",
    fontSize: 11,
    minWidth: 180,
  },
  _GAIv: {
    height: 40,
    backgroundColor: "#4#4#4",
    borderLeft: "1px solid #eee6e6",
    color: "#666",
    fontSize: 11,
    minWidth: 80,
    paddingRight: 10,
    textAlign: "right",
  },
  dataHeaderTd: {
    width: 100,
    paddingRight: 10,
    borderBottom: "1px solid #eee6e6",
  },
  dataTableBody: {
    fontSize: 11,
    paddingRight: 10,
    paddingBottom: 0,
    textAlign: "right",
    verticalAlign: "middle",
    border: "1px solid #eee6e6",
    height: "3em",
    overflowX: "auto",
  },
  dataCellTd: {
    fontSize: 13,
    paddingRight: 10,
    paddingBottom: 0,
    paddingLeft: 10,
    textAlign: "right",
    verticalAlign: "middle",
    borderBottom: "1px solid #eee6e6",
    borderRight: "1px solid #eee6e6",
    height: 45,
  },
  tTdHeader: {
    paddingLeft: "1rem",
    paddingRight: 19,
    fontWeight: "bold",
    height: 39,
  },
  tTd: {
    height: 44,
    width: 250,
    paddingLeft: "1rem",
    borderBottom: "1px solid #eee",
    borderCollapse: "collapse",
  },
  tableNumberData: {
    fontSize: 13,
    paddingBottom: 4,
  },
  exportBtn: {
    marginLeft: 16,
  },
  titleContainer: {
    display: "flex",
    flexWrap: "wrap",
  },
  widgetTitle: {
    flexBasis: "50%",
    fontSize: 16,
    padding: 16,
  },
  exportBtnContainer: {
    marginLeft: "auto",
    padding: 16,
  },
  labelCellTd: {
    fontSize: 13,
    paddingLeft: 10,
    paddingBottom: 0,
    textAlign: "left",
    verticalAlign: "middle",
    borderBottom: "1px solid #eee6e6",
    height: 45,
    minWidth: 200,
  }
});

const PicTreeTablePhotoSubTypeNtt = ({
  photoShootTrend,
  chartSize,
  pageTopLoader,
}) => {
  const classes = useStyles();
  const getTableLabelColumn = () => {
    const { assetSubTypeNtt } = assetConfig;

    const assetTypeKeys = [
      "TELEGRAPH_CONCRETE_POLE",
      "TELEGRAPH_CONCRETE_POLE_HAS_SUPPORT_POLE",
      "TELEGRAPH_STEEL_PIPE_POLE",
      "TELEGRAPH_STEEL_PIPE_POLE_HAS_SUPPORT_POLE",
      "TELEGRAPH_CONCRETE_LUCKY_POLE",
      "TELEGRAPH_CONCRETE_POLE_HAS_SUPPORT_LUCKY_POLE",
      "TELEGRAPH_STEEL_PIPE_LUCKY_POLE",
      "TELEGRAPH_STEEL_PIPE_POLE_HAS_SUPPORT_LUCKY_POLE",
    ];

    return (
      <>
        {assetTypeKeys.map((key) => (
          <tr key={key}>
            <td className={classes.labelCellTd}>{assetSubTypeNtt[key]}</td>
          </tr>
        ))}
      </>
    );
  };

  const getDataTable = (photoShootTrend) => {
    const trend = photoShootTrend[0] || {};
    const assetTypeKeys = [
      "TELEGRAPH_CONCRETE_POLE",
      "TELEGRAPH_CONCRETE_POLE_HAS_SUPPORT_POLE",
      "TELEGRAPH_STEEL_PIPE_POLE",
      "TELEGRAPH_STEEL_PIPE_POLE_HAS_SUPPORT_POLE",
      "TELEGRAPH_CONCRETE_LUCKY_POLE",
      "TELEGRAPH_CONCRETE_POLE_HAS_SUPPORT_LUCKY_POLE",
      "TELEGRAPH_STEEL_PIPE_LUCKY_POLE",
      "TELEGRAPH_STEEL_PIPE_POLE_HAS_SUPPORT_LUCKY_POLE",
    ];
    return (
      <>
        {assetTypeKeys.map((key) => {
          const values = trend[key];
          if (!values) return null;
          return (
            <tr key={key}>
              {values.map((val, i) => (
                <td className={classes.dataCellTd} key={i}>
                  {val}
                </td>
              ))}
            </tr>
          );
        })}
      </>
    );
  };

const getExportData = (photoShootTrend) => {
  const exportData = [];
  const { assetSubTypeNtt } = assetConfig;

  if (photoShootTrend.length > 0) {
    const numOfHeaderData = photoShootTrend[0]["date"].length;

    // 1. ヘッダー行（"アセット別撮影データ", 各日付）
    const headerArray = ["アセット別撮影データ"];
    for (let j = 0; j < numOfHeaderData; j++) {
      headerArray.push(moment(photoShootTrend[0]["date"][j]).format("M/D HH:mm"));
    }
    exportData.push(headerArray);

    // 2. 各アセットタイプごとの行
    const orderedKeys = [
      "TELEGRAPH_CONCRETE_POLE",
      "TELEGRAPH_CONCRETE_POLE_HAS_SUPPORT_POLE",
      "TELEGRAPH_STEEL_PIPE_POLE",
      "TELEGRAPH_STEEL_PIPE_POLE_HAS_SUPPORT_POLE",
      "TELEGRAPH_CONCRETE_LUCKY_POLE",
      "TELEGRAPH_CONCRETE_POLE_HAS_SUPPORT_LUCKY_POLE",
      "TELEGRAPH_STEEL_PIPE_LUCKY_POLE",
      "TELEGRAPH_STEEL_PIPE_POLE_HAS_SUPPORT_LUCKY_POLE",
    ];

    for (const key of orderedKeys) {
      const entry = photoShootTrend[0][key];
      if (entry && Array.isArray(entry)) {
        const row = [assetSubTypeNtt[key], ...entry];
        exportData.push(row);
      }
    }
  }

  return exportData;
};

  return (
    <Paper>
      <div className={classes.titleContainer}>
        <div className={classes.widgetTitle}></div>
        <div className={classes.exportBtnContainer}>
          <CSVLink
            data={getExportData(photoShootTrend)}
            filename={`PicTree - アセット別撮影トレンドデータ`}
          >
            <Button
              variant="contained"
              color="default"
              className={classes.exportBtn}
              startIcon={<GetApp />}
            >
              CSV出力
            </Button>
          </CSVLink>
        </div>
      </div>
      <div className={classes.tableContainer}>
        {pageTopLoader ? (
          <div className={classes.loaderBox}>
            <img
              className={classes.loaderBarImg}
              src={`/static/images/loader-bar.gif`}
            />
          </div>
        ) : photoShootTrend.length > 0 ? (
          photoShootTrend.length > 0 ? (
            <>
              <div className={classes.dateTableWrapper}>
                <table className={classes.leftTable}>
                  <tbody>
                    <tr>
                      <td className={classes.tTdHeader}></td>
                    </tr>
                    {getTableLabelColumn(photoShootTrend)}
                  </tbody>
                </table>
              </div>

              <div className={classes.dataTableWrapper}>
                <table className={classes.dataTableBody}>
                  <tbody>
                    <tr className={classes._GAIv}>
                      {photoShootTrend[0]["date"].map((item, i) => (
                        <td className={classes.dataHeaderTd} key={i}>
                          {chartSize !== "hour"
                            ? moment(item).format("M/D")
                            : moment(item).format("M/D HH:mm")}
                        </td>
                      ))}
                    </tr>
                    {getDataTable(photoShootTrend)}
                  </tbody>
                </table>
              </div>
            </>
          ) : (
            <div className={classes.loaderBox}>
              <C.NoData text="No Data" />
            </div>
          )
        ) : null}
      </div>
    </Paper>
  );
};

PicTreeTablePhotoSubTypeNtt.propTypes = {
  classes: PropTypes.object,
};

const mapStateToProps = (state) => ({
  photoShootTrend: state.pictreeNtt.photoShootTrendByAsset,
  chartSize: state.pictree.chartSize,
  pageTopLoader: state.page.pageTopLoader,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PicTreeTablePhotoSubTypeNtt);
